<template>
    <div class="bg">
        <vueHeader :navNum='4'></vueHeader>

        <div class="banner">
            <img src="./../assets/img/about/banner.jpg" alt="">
        </div>

        <div class="content wrap">
            <img class="logo" src="./../assets/img/about/logo.png" />

            <div class="title">公司简介</div>
            <div class="txt">
                <p>1999年我们进入医疗领域，是浙江省内最早涉及到科学地应对术中气道管理和血液动力学的专业公司之一，至今，我们在气道管理和血液动力学这两个专业已经积累了丰富的经验和产品。同时，我们也一直致力于家庭护理健康，给睡眠呼吸障碍病人引先进的产品及提供优质的服务。</p>
                <p>我们立足于医疗领域，并不断奋斗与创新，2007，Lotohof为进入健康领域花费时间精力和付出相当高的学习成本，肩负品牌使命，与医疗器械行业人士协同联动，为打造健康领域的优秀企业做了大量准备，并在抗衰老方向有颇多建树和经验积累。</p>
                <p>在2012年，我们正式进入健康领域，我们不仅自己从事这个领域的科学研究，更与世界顶尖医学学府合作。并且，我们拥有世界一流抗衰老实验室的合作资源，与抗衰老领域的权威专家广泛合作和交流。我们还有全球最为领先并独一无二的抗衰老疗法，专为少数尊贵的的客人提供稀有的抗衰老产品。</p>
                <p>同时，在2012年我们开始涉足中国德国之间的平行进口汽车贸易、德国波罗的海边的房地产开发，以及提供在德国的特别旅行和生活体验，我们汇集了我们能做到的最为极致之精华，希望能为您提供完全不同的人生之旅。</p>
                <p>2014年开始在德国进入专业的马术领域，Lotohof  Sporthorses Center位于德国萨尔州的萨尔-洪斯吕克自然公园内，面积约为15万平方米。我们有奥运选手和世锦赛选手的教学资源和经验，并且我们也拥有最具潜质的优秀马匹和一支专业技术管理队伍，始终致力于将马术这项“贵族运动”带入更多人的生活，让越来越多的人体会到马术的魅力。</p>
                <p>未来，我们将始终秉持着那份“尽我们最大的努力，把先进的治疗理念和领先的治疗手段带给我们的用户”的企业文化，从容应对发展路上的困难与问题，在新时代环境下创新发展，抓住新世纪新机遇，实现多领域新作为，作出医疗健康新贡献。</p>
            </div>

            <div class="title">成长大事件</div>
            <div class="grow">
                <img src="./../assets/img/about/time_line.png" alt="">
                <div class="event" :class="'event'+index" v-for="(item,index) in event" :key="index">
                    <div class="box">
                        <p class="time">{{item.time}}</p>
                        <p class="msg">{{item.event}}</p>
                    </div>
                </div>
            </div>
        </div>
        <vueFooter></vueFooter>
    </div>
</template>

<script>
import vueHeader from '@/components/header'
import vueFooter from '@/components/footer'
export default {
    data() {
        return {
            event: [
                {
                    time: '1999年',
                    event: 'Lotohof进入医疗领域，与多家医疗机构共同合作，学习积累医学经验。以公司的产品市场竞争优势，至今仍与数家大型医疗品牌进行密切的合作和业务往来。'
                },
                {
                    time: '2007年',
                    event: 'Lotohof为进入健康领域花费时间精力、付出相当高的学习成本，为打造健康领域的杰出企业做了大量准备，并在抗衰老方向有颇多建树和经验积累。'
                },
                {
                    time: '2012年',
                    event: 'Lotohof正式进入健康领域，我们不仅自己从事这个领域的科学研究，更与世界顶尖医学学府合作，专为尊贵的的客人提供稀有的抗衰老产品。同年Lotohof开始涉足中国德国之间的平行进口汽车贸易、德国波罗的海边的房地产开发，以及提供在德国的特别旅行和生活体验项目。'
                },
                {
                    time: '2014年',
                    event: 'Lotohof在德国进入专业的马术领域，具备奥运选手和世锦赛选手的丰富教学资源和经验，并且也拥有最具潜质的优秀马匹和一支专业技术管理队伍。'
                },
                {
                    time: '2017年',
                    event: 'Lotohof进入互联网健康领域，始终秉承Homecare理念，利用前沿科技运营国内外多个健康及医疗相关自媒体，为大众提供最新的医疗信息和健康服务。'
                },
                {
                    time: '2020年',
                    event: '至今，我们还与全国最顶级的医疗机构及全球最大的医疗器械生产企业等都有密切的业务往来。公司在医疗、健康、马术等领域全方面蓬勃发展，只为与您共创美好未来。'
                },
            ]
        }
    },

    mounted() {
        window.scrollTo(0, 0);
    },

    components: {
        vueHeader,
        vueFooter
    },
}

</script>

<style scoped lang='less'>
@import "./../assets/css/about.less";
</style>


// WEBPACK FOOTER //
// src/views/about.vue